import React from "react"; // ,{ useState }
import { messages } from "./i18n-messages";
import { DialogBox, DialogBoxFooterType } from "~/core";
import { useAppSelector } from "~/store/hooks";
import {
    getPortalAlternateInfoMessageModalOpen,
    getPortalAlternateInfoMessageType,
} from "~/action-panel/components/field-module/selectors";
import { injectIntl, intlShape } from "@ai360/core/intl";
import { useDispatch } from "react-redux";
import { actions as fieldActions } from "~/action-panel/components/field-module";

function PortalInfoMessageDialog({ intl: { formatMessage } }) {
    const isOpen = useAppSelector(getPortalAlternateInfoMessageModalOpen);
    const messageType = useAppSelector(getPortalAlternateInfoMessageType);

    const dispatch = useDispatch();

    const messageContent = messageType != null ? formatMessage(messages[messageType]) : null;

    return (
        <DialogBox
            draggable={true}
            isOpen={isOpen}
            footerType={DialogBoxFooterType.NONE}
            title={formatMessage(messages.titleForAdd)}
            onClose={() => {
                dispatch(fieldActions.setPortalAlternateInfoMessageModalOpen(false));
            }}
        >
            {messageContent}
        </DialogBox>
    );
}

PortalInfoMessageDialog.propTypes = {
    intl: intlShape,
};

export default injectIntl(PortalInfoMessageDialog);
